export enum Region {
  AMS = 'AMS',
  APJ = 'APJ',
  EMEA = 'EMEA',
}

export enum EMarket {
  latinAmerica = 'Latin America',
  northAmerica = 'North America',
  greaterAsia = 'Greater Asia',
  greaterChina = 'Greater China',
  india = 'India, B&SL',
  emea = 'EMEA',
}
